import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../library-js/dom-tools/ElementType"
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { Rokojori } from "../Rokojori";
import { UserData } from "./RokojoriUser";

export class UserName
{
  static readonly type = new ElementType<HTMLElement>( "user-name" );

  static _userNames:HTMLElement[] = [];
  static _initialized = false;
  
  static applyOnDocument()
  {
    UserName.initialize();
    this._userNames = [];
    UserName.type.forAllInDoc( e => UserName.applyOnElement( e ) );

    let userSystem = Rokojori.$.userSystem;
    this.setUserStatus( userSystem.isLoggedIn, userSystem.userName );
  }

  static initialize()
  {
    if ( UserName._initialized )
    {
      return;
    }

    UserName._initialized = true;

    Rokojori.$.userSystem.userID.addListener( 
      ( )=> 
      {
        let userSystem = Rokojori.$.userSystem;
        this.setUserStatus( userSystem.isLoggedIn, userSystem.userName );
      }
    );
  }

  static applyOnElement( e:HTMLElement )
  {
    this._userNames.push( e );
  }

  static setUserStatus( hasUser:boolean, userName:string )
  {
    this._userNames.forEach( i => UserName._updateUserNameElement( i, hasUser, userName ) )
  }

  private static _updateUserNameElement( e:HTMLElement, hasUser:boolean, userName:string = null )
  {

    if ( ! hasUser )
    {
      e.innerHTML = "";
    }
    else
    {
      HTMLEditor.setText( e, userName || "" ); 
    }
    
  }




}